import type {
    CvdKind
} from "./color";

export type CreatePreset = "nibgat" | "nibgat-community" | "caycore" | "custom";

export type CreateGreyTemperature = "auto" | "pure" | "warm" | "cool";

export type CreateThemeKey = "light" | "dark";

export type CreateDensity = "spacious" | "compact";

export type CreateSharpness = "soft" | "sharp" | "rounded";

export type CreateCornerShape = "squircle" | "round";

export type CreatePreviewKind = "components" | "dashboard-01" | "login-01" | "settings-01" | "chat-01" | "reading";

export type CreateReadingSize = "readingSmallSize" | "readingMediumSize" | "readingLargeSize";

export type CreateSettings = {
    greyTemperature: CreateGreyTemperature;
    readingSize: CreateReadingSize;
    cornerShape: CreateCornerShape;
    preview: CreatePreviewKind;
    sharpness: CreateSharpness;
    themeKey: CreateThemeKey;
    density: CreateDensity;
    preset: CreatePreset;
    brand: string;
};

export type CreateThemeTokens = Record<string, unknown>;

export type CreatePalette = {
    themes: Record<CreateThemeKey, CreateThemeTokens>;
    brandAdjusted: Record<CreateThemeKey, string>;
};

export type CreateChartCheckKey = "lightness" | "chroma" | "cvd" | "normal" | "contrast" | "spread";

export type CreateChartCheck = {
    key: CreateChartCheckKey;
    targets: Array<number>;
    series: Array<number>;
    values: Array<number>;
    worstKind?: CvdKind;
};

export type CreateContrastCheck = {
    chart?: CreateChartCheck;
    themeKey: CreateThemeKey;
    isApcaInfo: boolean;
    wcagTarget: number;
    apcaTarget: number;
    isPassing: boolean;
    labelKey: string;
    isGated: boolean;
    wcag: number;
    apca: number;
    fg: string;
    bg: string;
    id: string;
};

export type CreatePreviewMessage = {
    source: typeof CREATE_MESSAGE_SOURCE;
    settings: CreateSettings;
    palette: CreatePalette;
};

export const CREATE_MESSAGE_SOURCE = "ncore-docs-create";

export const CREATE_PALETTE_NAME = "create";

export const CREATE_VIEW_ID = "create";

export const CREATE_DEFAULT_SETTINGS: CreateSettings = {
    readingSize: "readingMediumSize",
    cornerShape: "squircle",
    greyTemperature: "auto",
    preview: "components",
    density: "spacious",
    sharpness: "soft",
    themeKey: "light",
    brand: "#006155",
    preset: "nibgat"
};
